import { render, staticRenderFns } from "./normalEditForm.vue?vue&type=template&id=6a70a0a4&scoped=true&"
import script from "./normalEditForm.vue?vue&type=script&lang=js&"
export * from "./normalEditForm.vue?vue&type=script&lang=js&"
import style0 from "./normalEditForm.vue?vue&type=style&index=0&id=6a70a0a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70a0a4",
  null
  
)

export default component.exports